<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar"
      color="var(--quomi-blue)"
      elevation="24"
      :timeout="timeout"
      transition="slide-y-reverse-transition"
      :multi-line="multiLine"
      :top="!$mq.isDesktop()"
      style="bottom: 10px"
      :class="{'mt-3': !$mq.isDesktop()}"
    >
      <span class="text-bold">{{ text }}</span>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    data: () => ({
      multiLine: false,
      snackbar: false,
      count: 0,
      text: null,
      firstText:`porzioni aggiunte al carrello`, 
      timeout: 4500,
    }),
    methods: {
      changeText(qty) {
        if (!qty) {
          qty = 1;
        }

        this.text = qty*2 + " " + this.firstText
        this.count++       
        setTimeout(()=> {
          if(this.count == 2) {
            this.text = `Complimenti! Il tuo costo a porzione è sceso a ${this.order.getPlanPricePerPortion().toFixed(2)} €`
          }else if(this.count == 3) {
            this.text = `Ottima scelta! Ora pagherai solo ${this.order.getPlanPricePerPortion().toFixed(2)} € a porzione.`
          }else if(this.count > 3) {
            this.text = `Fantastico! Hai raggiunto ${this.order.getPlanPricePerPortion().toFixed(2)} € a porzione.`
            this.count = 0
          }else {
            this.text = `Il costo a porzione è di ${this.order.getPlanPricePerPortion().toFixed(2)} €! Aggiungi altre ricette o porzioni e risparmia`
          }
        },1500)
        return this.text
      },
      resetCount() {
        return this.count = 0
      }
    },
    computed: {
      user () {
			  return this.$root.$data.user
	  	},
      order () {
        return this.user ? this.user.order : null
      },
    },
    created() {
			window.addEventListener('trigger-snackbar-recipes', (e) => {
          return this.snackbar = true && this.changeText(e.detail)
        });
      window.addEventListener('reset-count', () => {
          return this.resetCount()
        });
    },
    destroyed() {
      window.removeEventListener('trigger-snackbar-recipes', () => {
        return this.snackbar = true && this.changeText()
        }
      );
      window.removeEventListener('reset-count', () => {
          return this.resetCount()
        });
    }
  }
</script>

<style>
  .v-snack__content {
    text-align: center !important;
  }

  @media (max-width: 640px) {
    .v-snack__content {
      font-size: 12px !important ;
    }
    .v-snack__wrapper {
      min-width: fit-content !important;
      max-width: fit-content !important;
      bottom: 10px;
    }
  }
</style>